<template>
    <footer class="footer">
        <span>Copyright <strong> ML 18 </strong> © 2022-{{moment().format('YYYY')}} </span>
    </footer>  
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style>
    .footer {
        grid-area: footer;
        background-color: #DDD;
        color: #333;
        font-size: 0.78rem;

        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
    }
</style>
